import React from 'react';
import { Tabs, Tab, Box, useTheme, useMediaQuery } from '@mui/material';

const TAB_VALUES = [
  { label: 'Recent', value: 'recent' },
  { label: 'Unanswered', value: 'unanswered' },
  { label: 'Pinned', value: 'pinned' },
  { label: 'Solved', value: 'solved' },
  { label: 'Unsolved', value: 'unsolved' },
];

export default function ThreadFilterTabs({ value = 'recent', onChange }) {
  const theme = useTheme();
  const isSmall = useMediaQuery(theme.breakpoints.down('sm'));

  const handleChange = (event, newValue) => {
    if (onChange) onChange(newValue);
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Tabs
        value={value}
        onChange={handleChange}
        variant={isSmall ? 'scrollable' : 'standard'}
        scrollButtons={isSmall ? 'auto' : false}
        TabIndicatorProps={{ sx: { backgroundColor: theme.palette.success.main } }}
        aria-label="thread filter tabs"
      >
        {TAB_VALUES.map((tab) => (
          <Tab
            key={tab.value}
            label={tab.label}
            value={tab.value}
            sx={{
              fontSize: '1rem',
              textTransform: 'none',
              minHeight: 40,
              py: 0,
              mb: 0,
            }}
          />
        ))}
      </Tabs>
    </Box>
  );
}
